import { TranslateFn } from 'src/localization/translate'
import { CountryFieldModel } from 'src/models/country.models'

type AddressulatorField = Pick<
  CountryFieldModel,
  'label' | 'name' | 'options'
>

/**
 * Addressulator localizes field and option labels for the requested locale, so
 * callers must render those labels directly. Only placeholder copy is owned by
 * the app and passed through our translation catalog here.
 */
export const getAddressFieldPlaceholder = (
  country: string,
  field: AddressulatorField,
  translate: TranslateFn,
): string => {
  const { label, name, options } = field

  if (options !== undefined) {
    if (country === 'CA') return translate('Select your Province')
    if (country === 'US') return translate('Select your State')
    return translate('Select your ${label}', { label })
  }

  if (name === 'postal') {
    if (country === 'US') return '#####'
    if (country === 'CA') return '### ###'
    return translate('Enter Postal Code')
  }

  if (country === 'US' || country === 'CA') {
    if (name === 'address1') return translate('Enter Billing Address 1')
    if (name === 'address2') return translate('Enter Billing Address 2')
    if (name === 'city') return translate('Enter City')
  }

  return translate('Enter ${label}', { label })
}
